import {
  all,
  AllEffect,
  ForkEffect,
  put,
  select,
  take,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { parseFrontendError } from "@/fe-core/helpers/general";

import {
  IBalanceChangeResponsePayload,
  IBalanceChangeViewModel,
  IBalanceViewModel,
} from "@/fe-core/meta/interfaces/user";

import {
  userActionTypes,
  BalanceChangedAction,
} from "@/fe-core/meta/types/user";
import { clearState } from "@/fe-core/_redux/actions/rootActions";
import {
  getBalanceFailure,
  getBalanceSuccess,
  balanceUpdate,
  getBalanceRequest,
} from "@/fe-core/_redux/actions/userActions";
import { headerKeys } from "@/config/general";
import { sessionDataSelector } from "@/fe-core/_redux/selectors/sessionSelectors";
import { IErrorPayload, IJsonResponse } from "@/fe-core/meta/interfaces/root";
import { methodTypes } from "@/fe-core/meta/types/root";
import { buffers, eventChannel } from "redux-saga";
import { NotUndefined, Buffer } from "@redux-saga/types";
import { Action } from "redux";
import { localeSelector } from "@/fe-core/_redux/selectors/localeSelectors";
import { localeActionTypes } from "@/fe-core/meta/types/locale";
import { clearStorage } from "@/fe-core/helpers/register";
const balanceChangedPayloadToViewModel = ({
  balanceChange,
}: IBalanceChangeResponsePayload): IBalanceChangeViewModel => {
  const result: IBalanceChangeViewModel = {};
  if (
    balanceChange?.Real?.affectedAmount !== undefined &&
    balanceChange?.Real?.afterAmount !== undefined
  ) {
    result.Real = {
      affectedAmount: balanceChange.Real.affectedAmount,
      afterAmount: balanceChange.Real.afterAmount,
    };
  }
  if (
    balanceChange?.Bonus?.affectedAmount !== undefined &&
    balanceChange?.Bonus?.afterAmount !== undefined
  ) {
    result.Bonus = {
      affectedAmount: balanceChange.Bonus.affectedAmount,
      afterAmount: balanceChange.Bonus.afterAmount
    };
  }
  return result;
};

function* getBalanceRequestSaga() {
  try {
    const { sessionId } = yield select(sessionDataSelector);
    const { locale } = yield select(localeSelector);

    if(!sessionId) return;

    const response: IJsonResponse<IBalanceViewModel | IErrorPayload> =
      yield fetch("/api/user/balance", <RequestInit>{
        method: methodTypes.GET,
        headers: new Headers({
          [headerKeys.SESSION_ID]: sessionId,
          [headerKeys.LOCALE]: locale,
        }),
      });

    const viewModel: IBalanceViewModel = yield response.json();
    if (response.status == 200) {
      yield put(getBalanceSuccess(viewModel));
    } else {
      // @ts-ignore
      if (response.status === 401 || (response.status === 400 && viewModel?.message === "Session not found")) {
        yield put(clearState());
        clearStorage();
      }

      const errorPayload: IErrorPayload = yield response.json();
      yield put(getBalanceFailure(errorPayload));
    }
  } catch (error) {
    yield put(getBalanceFailure(parseFrontendError(error)));
  }
}



function* balanceChangedSaga({ payload }: BalanceChangedAction) {
  // const balance: IBalanceViewModel = yield select(userBalanceDataSelector);
  // const userData: ISessionViewModel | null = yield select(sessionDataSelector);
  //
  // if (payload.type === "Deposit") {
  //   const eventType = payload.isFirstDeposit ? "first-deposit" : "deposit";
  //
  //   const depositValue = payload.amount - balance.balance;
  //
  //   TagManager.dataLayer({
  //     dataLayer: {
  //       event: eventType,
  //       userId: userData?.userId,
  //       username: encodeToB64(userData?.username || ""),
  //       email: userData?.email || "",
  //       depositValue: parseFloat(depositValue.toFixed(2)),
  //     },
  //   });
  // }

  yield put(balanceUpdate(payload));
}

export default function* balanceSaga(): Generator<
  AllEffect<ForkEffect<never>>,
  void,
  unknown
> {
  yield all([
    takeEvery(userActionTypes.GET_BALANCE_REQUEST, getBalanceRequestSaga),
    takeLatest(userActionTypes.APPLY_BONUS_SUCCESS, getBalanceRequestSaga),
    takeLatest(localeActionTypes.SET_CURRENT_LOCALE, getBalanceRequestSaga),
    takeLatest(userActionTypes.GET_CLAIM_SUCCESS, getBalanceRequestSaga),
    takeLatest(userActionTypes.BALANCE_CHANGED, balanceChangedSaga),
  ]);
}
